<template>
  <NavigationIndex :route-url="routeUrl" />
</template>

<script setup lang="ts">
import type { GnbRouteUrl } from '~/types/layouts/navigation'

const { partnersKey } = storeToRefs(usePartnerStore())

const routeUrl = ref<GnbRouteUrl>({
  home: `/partners/${partnersKey.value}`,
  inventory: `/partners/${partnersKey.value}/inventory`,
  user: `/partners/${partnersKey.value}/user`,
  setting: `/partners/${partnersKey.value}/settings`
})

</script>
